var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Compare Slider","active":""}},[_c('b-form-group',{staticClass:"mb-0"},[_c('b-checkbox',{model:{value:(_vm.section.options.content.compare.vertical),callback:function ($$v) {_vm.$set(_vm.section.options.content.compare, "vertical", $$v)},expression:"section.options.content.compare.vertical"}},[_vm._v(" Vertical ")])],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Before Image"}},[_c('sid-upload-image',{attrs:{"sid":`.--${_vm.section.sid}-- .after-image`,"title":"","rule-name":"content"}}),_c('sid-width-and-height',{attrs:{"sid":`.--${_vm.section.sid}-- .after-image`}}),_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}-- .after-image`,"rule-name":"filter"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"After Image"}},[_c('sid-upload-image',{attrs:{"sid":`.--${_vm.section.sid}-- .before-image`,"title":"","rule-name":"content"}}),_c('sid-width-and-height',{attrs:{"sid":`.--${_vm.section.sid}-- .before-image`}}),_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}-- .before-image`,"rule-name":"filter"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Handler Button"}},[_c('b-form-group',[_c('sid-checkbox',{attrs:{"unchecked-value":"flex","value":"none","rule-name":"display","sid":`.--${_vm.section.sid}-- .handler-button`}},[_vm._v(" Hide Button ")])],1),_c('b-form-group',[_c('icon-select',{model:{value:(_vm.section.options.content.compare.handleIcon),callback:function ($$v) {_vm.$set(_vm.section.options.content.compare, "handleIcon", $$v)},expression:"section.options.content.compare.handleIcon"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"mb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}-- .handler-button .handler-icon`}})],1)]),_c('sid-range-slider',{attrs:{"label":"Width","rule-name":"width","sid":`.--${_vm.section.sid}-- .handler-button`}}),_c('sid-range-slider',{attrs:{"label":"Height","rule-name":"height","sid":`.--${_vm.section.sid}-- .handler-button`}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}-- .handler-button`}}),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}-- .handler-button`,"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}-- .handler-button`,"rule-name":"border-color","allow-reset":""}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Link Border Radius","sid":`.--${_vm.section.sid}-- .handler-button`,"rule-name":"border","angles":[
        {
          text: '',
          value: 'top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Handler Line"}},[_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Width","rule-name":"--handler-size","sid":`.--${_vm.section.sid}--`}})],1),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}-- .handler`}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--`,"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--`,"rule-name":"border","angles":[
        {
          text: '',
          value: 'top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Margins"}},[_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }